import React from 'react';
import {injectIntl} from 'react-intl';
import {useHistory, useRouteMatch} from 'react-router-dom';
import ButtonPreloader from '@FormComponents/ButtonPreloader';
import filtersToQueryString from 'filtersToQueryString';

const Pager = ({intl, searchParams, totalMatches, itemsPerPage, loading, setLoading}) => {
  const route = useRouteMatch();
  const history = useHistory();
  const currentPage = searchParams.page ? parseInt(searchParams.page) : 1;
  const resultsCount = itemsPerPage * currentPage > totalMatches ? totalMatches : itemsPerPage * currentPage;
  const resultsLeft = totalMatches - resultsCount;
  const pages = Math.ceil(totalMatches / itemsPerPage);

  if (resultsLeft === 0) {
    return null;
  }

  const indicatorWidth = (resultsCount / totalMatches) * 100;

  const seoPager = [];
  let seoPage = searchParams.page ? parseInt(searchParams.page) : 1;
  while (seoPager.length < 20 && seoPage <= pages) {
    const pagerBuilder = {...searchParams};
    pagerBuilder.page = seoPage;

    const url = `${route.path}/?${filtersToQueryString(pagerBuilder)}`;

    seoPager.push(<a key={`page-${seoPage}`} href={url}>{seoPage}</a>);
    seoPage ++;
  }

  const nextPageUrl = () => {
    searchParams.page = currentPage + 1;

    return searchParams;
  };

  const loadMore = (event) => {
    event.preventDefault();
    setLoading(true);
    const search = nextPageUrl();

    history.push({
      'pathname': '/find-employees/search-result/',
      'search': filtersToQueryString(search),
    });
  };

  return (
    <>
      <div className="show-more mb-m">
        <div className="show-more__indicator">
          <div className="indicator-percentage">
            <div className="indicator-percentage__background">
              <div className="indicator-percentage__amount" style={{width: `${indicatorWidth}%`}}/>
            </div>
          </div>
        </div>
        <div className="section-separator section-separator--border">
          <span>
            { intl.formatMessage({id: 'Pager.ResultsOf'}, {results: resultsCount, total: totalMatches})}
          </span>
        </div>
        <ButtonPreloader className="button button--m bluex-button--preloader button--blue" onClick={loadMore} disabled={loading}>
          <span className="button__text">
            {
              intl.formatMessage({id: 'Pager.ViewMore'}, {
                count: resultsLeft <= itemsPerPage ? resultsLeft : itemsPerPage,
              })
            }
          </span>
        </ButtonPreloader>
      </div>
      {
        seoPager.length > 0 ?
          <noscript><div className="seoPager"> {seoPager} </div></noscript> : ''
      }
    </>
  );
};

export default injectIntl(Pager);
